//Data.js
export const galleryData = [
  {
    section: 'Landscape Design & Build',
    folder: 'landscape',
    navLink: '/landscape',
    accentColor: 'evergreen',
    images: [
      { src: '/images/projects/maintenance/maintenancefeature4A.jpg', alt: 'Modern landscape design with native plants' },
      { src: '/images/landscape/treeWall.JPG', alt: 'Garden with retaining wall' },
      { src: '/images/landscape/frontLawn.png', alt: 'Sustainable drought-resistant landscaping' },
      { src: '/images/landscape/treeBush.JPG', alt: 'Complete outdoor transformation' },
      { src: '/images/landscape/flowersTreeFence.JPG', alt: 'Fencing, trees, and flowers' },
      { src: '/images/landscape/nativePlant.JPG', alt: 'Native Idaho plant installation' },
      { src: '/images/landscape/gardenNative.png', alt: 'Natural Landscape updated' },
    ]
  },
  {
    section: 'Hardscape Construction',
    folder: 'hardscape',
    navLink: '/hardscape',
    accentColor: 'bark-brown',
    images: [
      { src: '/images/hardscape/galleryHardHero1.jpg', alt: 'Outdoor living realized' },
      { src: '/images/hardscape/backyardSunRetreat2.png', alt: 'Custom outdoor retreat with pergola and built-in fire table' },
      { src: '/images/hardscape/pavers.png', alt: 'Modern garden path with concrete pavers and blooming summer perennials' },
      { src: '/images/hardscape/waterfall.jpg', alt: 'Waterfall with stone and rock' },
      { src: '/images/hardscape/PaverGallery.JPG', alt: 'Beautiful pavers in garden' },
      { src: '/images/hardscape/hardscapeGarden.png', alt: 'Decorative multi-level garden' },
      { src: '/images/hardscape/harscapeCommunity.png', alt: 'Updating community hardscape' },
      { src: '/images/hardscape/hardscapeKitchen.png', alt: 'Outdoor kitchen' },
      { src: '/images/hardscape/outdoorLiving.JPG', alt: 'Relaxing by the water' },
    ]
  },
  // {
  //   section: 'Tree Services',
  //   folder: 'tree',
  //   navLink: '/tree',
  //   accentColor: 'evergreen',
  //   images: [
  //     { src: '/images/tree/treeHeroImage2.png', alt: 'Our tree farm' },
  //     { src: '/images/tree/treeAS.jpg', alt: 'Large tree removal project' },
  //     { src: '/images/tree/matureTree.png', alt: 'Bring grown trees to landscape' },
  //     { src: '/images/tree/treeInstallation.png', alt: 'Planting new trees (AI GEN' },
  //     { src: '/images/tree/treeMaintenance1.jpg', alt: 'Emergency storm damage cleanup' }
  //   ]
  // },
  {
    section: 'Fire Pit Installations',
    folder: 'fire',
    navLink: '/fire',
    accentColor: 'fireweed-red',
    images: [
      { src: '/images/fire/caldranFire.png', alt: 'Caldran Fire' },
      { src: '/images/fire/customPitNight.jpg', alt: 'Modern stone firepit' },
      { src: '/images/fire/fireHeroImage.png', alt: 'Modern stone firepit - evening' },
      { src: '/images/fire/seatingFirePit.png', alt: 'Fire pit patio transformation' },
      { src: '/images/fire/groundFirePit.png', alt: 'Built in fire pit.' },
      { src: '/images/fire/firePitAS.jpg', alt: 'Fire pit view' }
    ]
  },
  {
    section: 'Holiday Lighting',
    folder: 'holiday',
    navLink: '/light',
    accentColor: 'sunlit-gold',
    images: [
      { src: '/images/lights/holidayAngle.png', alt: 'Elegant home holiday lighting' },
      { src: '/images/lights/treeLandscape.jpeg', alt: 'Beautiful tree landscape' },
      { src: '/images/lights/coverTrees.jpeg', alt: 'Tree lighting in vibrant colors' },
      { src: '/images/lights/holidayGreenTrees.png', alt: 'Commercial trees light show' },
      { src: '/images/lights/holidayOutline.png', alt: 'Custom holiday light design' },
      { src: '/images/lights/holidayStar.png', alt: 'Custom holiday full design' },
      { src: '/images/lights/holidayTrees.png', alt: 'Commercial custom holiday light design for trees' },
      { src: '/images/lights/lights5.jpg', alt: 'Custom backyard tree light design' },
    ]
  },
  {
    section: 'Seasonal Floral',
    folder: 'flower',
    navLink: '/flower',
    accentColor: 'bloom-pink',
    images: [
      { src: '/images/flower/flowerHeroImage.png', alt: 'Our greenhouse' },
      { src: '/images/flower/flowerBed.png', alt: 'Summer natural flowers' },
      { src: '/images/flower/catTails.JPG', alt: 'Fall flowers' },
      { src: '/images/flower/redWhiteBuds.jpg', alt: 'Garden planning' },
      { src: '/images/flower/purpleSpike.JPG', alt: 'Container garden arrangements' },
      { src: '/images/flower/redWhiteBloom.jpg', alt: 'Blooming gardens' },
      { src: '/images/flower/greenHouseFlowers.jpg', alt: 'Our greenhouse selections' },
      { src: '/images/flower/lilPurples.jpg', alt: 'Colorful blooms' },
      { src: '/images/flower/entryFlower.JPG', alt: 'A simple pop of color' }
    ]
  },
  {
    section: 'Water Features',
    folder: 'water',
    navLink: '/waterFeature',
    accentColor: 'sky-blue',
    images: [
      { src: '/images/water/pond.png', alt: 'Natural pond installation' },
      { src: '/images/maintenance/watertreeslawnshrub1.jpg', alt: 'Modern fountain feature' },
      { src: '/images/water/waterfall.png', alt: 'Waterfall and stream design' },
      { src: '/images/water/waterManage.JPG', alt: 'Koi pond construction' },
      { src: '/images/water/pondGreen.jpg ', alt: 'Pond tranquility' },
      { src: '/images/water/pondCreated1.jpg', alt: 'Pond maintenance' },
      { src: '/images/maintenance/maintenanceHero.jpg', alt: 'Waterfall maintenance' },
      
    ]
  },
  {
    section: 'Custom Fencing',
    folder: 'fencing',
    navLink: '/fencing',
    accentColor: 'bark-brown',
    images: [
      { src: '/images/fence/barbFencing.png', alt: 'Barbed wire fencing' },
      { src: '/images/fence/fenceHeroImage.png', alt: 'Beautiful wood custom fence' },
      { src: '/images/fence/coralsArenasFencing.png', alt: 'Ranch style wood fence' },
      { src: '/images/fence/highTensionFixedKnotFencing.png', alt: 'High tension knot fencing' },
      { src: '/images/fence/topRailFencing.png', alt: 'Top Rail Fencing' },
      { src: '/images/fence/fenceBeauty.jpg', alt: 'A fence so beautifully incorporated' }
    ]
  },
  {
    section: 'Tree Farm',
    folder: 'treefarm',
    navLink: '/TreeFarm',
    accentColor: 'evergreen',
    images: [
      { src: '/images/tree/treeHeroImage3.jpg', alt: 'All Seasons Tree Farm overview' },
      { src: '/images/tree/treeFarm/treeFMultiPath.JPG', alt: '30 acres of meticulously maintained tree rows' },
      { src: '/images/tree/treeFarm/treeFPineLovely.JPG', alt: 'Spectacular fall colors in our deciduous section' },
      { src: '/images/tree/treeFarm/treeFLarge.JPG', alt: 'Personal tree selection consultations' },
      { src: '/images/tree/treeFarm/treeFFullSmall.JPG', alt: 'Tree Farm young' },
      { src: '/images/tree/treeFarm/treeFpath.JPG', alt: 'Golden hour at All Seasons Tree Farm' },
      { src: '/images/tree/treeFarm/treeFPineMassPath.JPG', alt: 'Tree Farm Pines' },
      { src: '/images/tree/treeFarm/treeFTallThin.JPG', alt: 'Sunset at the Tree Farm' },
      { src: '/images/tree/treeFarm/treeFXmasPretty.JPG', alt: 'Morning in the pines' },
    ]
  },
  // {
  //   section: 'Snow Removal',
  //   folder: 'snow',
  //   navLink: '/Snow',
  //   accentColor: 'clean-snow',
  //   images: [
  //     { src: '/images/snow/snowSalt.png', alt: 'Commercial snow removal service' },
  //     { src: '/images/snow/snow2.jpg', alt: 'Residential driveway clearing' },
  //     { src: '/images/snow/snow3.jpg', alt: 'Snow removal equipment fleet' },
  //     { src: '/images/snow/snow4.jpg', alt: 'Sidewalk snow clearing' },
  //     { src: '/images/snow/snow5.jpg', alt: '24/7 emergency snow service' }
  //   ]
  // },
  // {
  //   section: 'Estate Management',
  //   folder: 'estate',
  //   navLink: '/estate',
  //   accentColor: 'evergreen',
  //   images: [
  //     { src: '/images/estate/estate1.jpg', alt: 'Large estate maintenance' },
  //     { src: '/images/estate/estate2.jpg', alt: 'Estate garden management' },
  //     { src: '/images/estate/estate3.jpg', alt: 'Luxury property landscaping' },
  //     { src: '/images/estate/estate4.jpg', alt: 'Estate grounds transformation' }
  //   ]
  // },
  // {
  //   section: 'Commercial Properties',
  //   folder: 'commercial',
  //   navLink: '/commercial',
  //   accentColor: 'slate',
  //   images: [
  //     { src: '/images/commercial/commercial1.jpg', alt: 'Office building landscaping' },
  //     { src: '/images/commercial/commercial2.jpg', alt: 'Retail center maintenance' },
  //     { src: '/images/commercial/commercial3.jpg', alt: 'HOA common area design' },
  //     { src: '/images/commercial/commercial4.jpg', alt: 'Commercial property enhancement' }
  //   ]
  // }
];